'use strict';

import $ from 'jquery';
import Mustache from 'mustache';
import utils from '../util';
import getToken from '../api/token';
import { getShops } from '../api/shops';
import { getUser } from '../api/users';
import Promise from 'bluebird';
import { inputFilteringEvents } from '../util/form';

export default async function (renderNow) {
	const $window = $(window);
	const $document = $(document);
	const $html = $('html');
	const $productForm = $('.v4-product-card form');
	const $clickAndCollect = $('.v4-product-click-and-collect');
	const template = $('#template-click-and-collect').html();

	// render to .store-availability
	const productPageTemplate = `


{{^sizeSelected}}
<div class="store-availability-container">
  <div class="store-list-header">
    <h3 class="title">Tarkista saatavuus ja tilaa myymälästä</h3>
    <div class="subtitle">Sijaintiasi lähinnä olevat myymälät</div>
  </div>
  <div class="notification">
	<p>Valitse koko nähdäksesi myymäläsaatavuuden.</p>
  </div>
</div>
{{/sizeSelected}}

{{#sizeSelected}}
<div class="store-availability-container">
  <div class="store-list-header">
    <h3 class="title">Tarkista saatavuus ja tilaa myymälästä</h3>
    <div class="subtitle">Sijaintiasi lähinnä olevat myymälät</div>
  </div>
  <div class="store-list-items">
    {{#stores}}
    <div class="store-item" data-store-id="{{id}}" data-store-price="{{balanceData.price}}" data-bonus-store-price="{{balanceData.bonusPrice}}">
      <div class="store-details">
        <div class="store-info">
          <div class="store-name"><a href="{{storeData.link}}">{{storeData.name}}</a></div>
          <div class="store-hours">{{{storeData.formattedOpeningInfo}}}</div>
        </div>
        <div class="store-status">
          <div class="store-availability with-icon">
            {{^balanceData.hasLowBalance}}
                <div class="status-dot"></div>
                <div>Hyvä saatavuus</div>
            {{/balanceData.hasLowBalance}}
            {{#balanceData.hasLowBalance}}
                <div class="status-dot yellow"></div>
                <div>Viimeisiä viedään</div>
            {{/balanceData.hasLowBalance}}
          </div>
          <div class="store-price">{{#formatPrice}}{{balanceData.price}}{{/formatPrice}}</div>
        </div>
      </div>
      <button type="button" class="a-button a-button--small order-product-button store-action-btn" {{^canShip}}disabled{{/canShip}}>
        Tilaa myymälästä
      </button>
    </div>
    {{/stores}}
  </div>
  <div class="store-availability-footer">
    <div class="view-all-link">Katso kaikkien myymälöiden varastosaldot ja tilaa myymälästä</div>
  </div>
</div>
{{/sizeSelected}}


	`;

	const templateData = {
		reservation: {},
		product: {},
		errors: {},
		geoLocation: {},
		loaders: {},
		stores: [],
		cities: [],
		hasStores: false,
		selectFirstOption: false,
		disableCc: false,
		disableCcTitle: '',
		disableCcText: '',
		productQuestions: [],
		hasProductQuestions: false,
		hasProductQuestionsInfoLink: false,
		productQuestionsInfoLink: '',
		productQuestionsInfoLabel: '',
		formatPrice: function () {
			return function (text, render) {
				return formatPrice(render(text));
			};
		},
	};

	let loggedIn = 0;

	// Default shipment prices for Click & Pay (previously Click & Collect)
	const SHIPMENT_PRICES = {
		posti: {
			default: 7.9,
			club: 5.9,
		},
		kotiintoimitus: {
			default: 11.9,
			club: 9.9,
		},
		special: {
			default: 49.9,
			club: 24.9,
		},
		nouto: {
			default: 0,
			club: 0,
		},
	}

	// Shipment types used in the reservation form. Can be overridden by window.ccShipmentTypes
	const shipmentTypes = { ...SHIPMENT_PRICES };

	const customShipmentTypes = [];

	// Set by checkIfUserHasValidPlussaCard(). Mirrors the backend, which applies the
	// bonus price and plussa campaigns only for a validated K-Plussa number.
	// Reset whenever a new reservation is started (updateReservationData).
	let plussaCardValidated = false;
	// Server validation results per card number, so the same number is validated once
	const plussaValidationCache = new Map();
	// Price last sent to /stage-ajax/freeDeliveries, to skip repeated identical lookups
	let lastFreeDeliveryPrice = null;
	// Sequence number of the latest free delivery lookup; only the newest may commit
	let freeDeliveryLookupSeq = 0;

	function isValidDateObject(date) {
		return date instanceof Date && !isNaN(date);
	}

	function isValidSaleCampaignProduct(saleCampaignIds, productCampaignIds) {
		const productsCampaigns = productCampaignIds?.toString().split(',') || [];
		return productsCampaigns.some((productCampaign) =>
			saleCampaignIds.includes(productCampaign)
		);
	}

	const isLoggedIn = window.user?.loggedIn === true;
	const productData = $productForm.data();
	templateData.retailPrice = parseFloat(productData.retailPrice);

	// Overrides default C&P shipment types. If these are not set, defaults will be used.
	// Currently only used for SUP boards - they use slightly different "kotiintoimitus" style shipment type and the price is different.
	// I.e. it's a "semi-special" shipment type.

	if (window.ccShipmentTypes && window.ccShipmentTypes !== 'false') {
		try {
			const ccShipmentTypes = window.ccShipmentTypes;
			const shipmentTypesArray = Array.isArray(ccShipmentTypes);
			if (shipmentTypesArray) {
				for (const shipmentType of ccShipmentTypes) {
					customShipmentTypes.push(shipmentType);
					shipmentTypes[shipmentType.id] = {
						default: shipmentType.default,
						club: shipmentType.club,
					};
				}
			}
		} catch (error) {
			// Could not parse shipment types, will use defaults.
		}
	}

	const campaignSaleData = await getCNPCampaigns();
	let hasActiveClickAndCollectSale = false;
	let clubSale = false;
	let plussaSale = false;
	let brandSale = false;
	let normalPriceSale = false;
	let validCNPCampaigns = [];

	/**
	 * Find the best sale campaign for the given product, based on salePercentage.
	 *
	 * @param {Object[]} campaigns The campaigns to check, as returned by getCNPCampaigns()
	 * @param {string} [campaignType] Check only campaigns of this type. Optional.
	 * @returns {Object} A single campaign object with the highest salePercentage, or null if no valid campaign was found.
	 */
	function findBestSaleCampaign(campaigns, campaignType) {
		if (campaignType)
			return findBestSaleCampaign(
				campaigns.filter((campaign) => campaign.campaignType === campaignType)
			);

		return campaigns.reduce((bestCampaign, currentCampaign) => {
			return !bestCampaign ||
				currentCampaign.salePercentage > bestCampaign.salePercentage
				? currentCampaign
				: bestCampaign;
		}, null);
	}

	function updateCampaigns() {
		// Toggle visibility of sale info boxes
		hasActiveClickAndCollectSale = false;
		clubSale = false;
		plussaSale = false;
		brandSale = false;
		normalPriceSale = false;
		validCNPCampaigns = [];

		// Different campaigns (plussa, club/loggedIn, and brand) can be scheduled in the database table cnp_campaigns.

		validCNPCampaigns = campaignSaleData.filter((sale) =>
			campaignIsValidForProduct(sale, productData)
		);

		hasActiveClickAndCollectSale =
			validCNPCampaigns.length > 0 && !productData.campaignDisabledForCc;
		clubSale = validCNPCampaigns.some(
			(campaign) => campaign.campaignType === 'club'
		);
		plussaSale = validCNPCampaigns.some(
			(campaign) => campaign.campaignType === 'plussa'
		);
		brandSale = validCNPCampaigns.some(
			(campaign) => campaign.campaignType === 'brand'
		);
		normalPriceSale = validCNPCampaigns.some(
			(campaign) => campaign.campaignType === 'fromNormalPrice'
		);

		//const bestValidCampaign = findBestSaleCampaign(validCNPCampaigns);
		// const bestSalePercentage = bestValidCampaign?.salePercentage || 0;
		// const campaignSaleMultiplier = 1.0 - bestSalePercentage;

		if (hasActiveClickAndCollectSale) {
			// Pick best sale campaign of each sale type and prepare it for the template
			// These can be used in the template like this:
			// {{#saleCampaigns.club}}Get a discount of {{salePercentage}}% with your club membership!{{/saleCampaigns.club}}
			const saleTypes = ['club', 'plussa', 'brand', 'fromNormalPrice'];

			templateData.saleCampaigns = [];
			saleTypes.forEach((saleType) => {
				// Reset sale campaign data
				templateData[
					`show${saleType.charAt(0).toUpperCase() + saleType.slice(1)}SaleInfo`
				] = false;
			});

			saleTypes.forEach((saleType) => {
				const bestSaleCampaign = findBestSaleCampaign(
					validCNPCampaigns,
					saleType
				);
				if (bestSaleCampaign) {
					const retailPrice = parseFloat(productData.retailPrice);
					templateData.saleCampaigns[saleType] = {
						salePercentage: (bestSaleCampaign.salePercentage * 100).toFixed(0),
						retailPrice: retailPrice
							? String(retailPrice.toFixed(2)).replace('.', ',')
							: false,
						saleBannerText: bestSaleCampaign.saleBannerText || false,
					};

					templateData[
						`show${
							saleType.charAt(0).toUpperCase() + saleType.slice(1)
						}SaleInfo`
					] = true;
				}
			});
		}
	}

	templateData.isLoggedIn = isLoggedIn;

	if ($productForm.length) {
		const {
			disableCc,
			saleProduct,
			sellingStarts,
			sellingEnabled,
			campaignBanner,
			vmChainCampaign,
			// DEPRECATED: freeDeliveryCp should not be used, free delivery is determined on order button click
			// freeDeliveryCp,
		} = $productForm.data();
		if (sellingStarts) {
			templateData.sellingStarts = $productForm.data('selling-starts');
		}
		// Last Chance products must not offer store-specific availability or purchase.
		if (disableCc || saleProduct === 'lastchance') {
			templateData.disableCc = true;
			// The server-rendered placeholder is shown until a color/size change
			// triggers renderData(), so hide it immediately here too.
			$('.store-availability').empty();
			if (campaignBanner) {
				templateData.campaignBanner = campaignBanner;
			}
		}

		// DEPRECATED: freeDeliveryCp flag is no longer used
		// Free delivery eligibility is checked when order button is clicked

		const ccDisableStart = new Date('2024/04/08 07:00:00');
		const ccDisableEnd = new Date('2024/04/16 02:59:59');

		templateData.vmEnableCp = true;

		if (ccDisableStart < new Date() && ccDisableEnd > new Date()) {
			templateData.vmProduct = $('.v4-product').hasClass('vm-product');
			templateData.vmEnableCp =
				$('.v4-product').hasClass('vm-product') &&
				$productForm.data('sellingEnabled') === true;
			//const campaignIds = $productForm.not('.extra-sale-product').data('campaign-ids')+'' || null;
			//templateData.vmProduct = campaignIds ? (campaignIds.indexOf('0373') !== -1 || campaignIds.indexOf('0374') !== -1) : false;
		}

		if ($productForm.data('enable-cp-for-special-delivery')) {
			templateData.enableCCforSpecialDelivery = true;
		}

		templateData.vmChainCampaign = vmChainCampaign;

		if (!sellingEnabled) {
			templateData.sellingDisabled = true;
		}
		if (templateData.disableCampaignCc && !templateData.sellingDisabled) {
			templateData.sale = true;
		}

		[
			'campaignName',
			'sellingStarts',
			'campaignPrice',
			'campaignDay',
			'disableCcTitle',
			'disableCcText',
			'disableCc',
		].forEach((prop) => {
			if (productData[prop]) {
				templateData[prop] = productData[prop];
			}
		});
		/*
		if (campaignName) {
			templateData.campaignName = campaignName;
		}
		if (sellingStarts) {
			templateData.sellingStarts = sellingStarts;
		}
		if (campaignPrice) {
			templateData.campaignPrice = campaignPrice;
		}
		if (campaignDay) {
			templateData.campaignDay = campaignDay;
		}*/
	}

	let shopsLoaded = false;
	let userInfo = null;
	let shops = {};

	//const shops = $clickAndCollect.data('shops') || {};
	const storeBalances = {};

	let isActived = false;
	let jqXHR;

	clickAndCollectEvents();
	productFormEvents();

	// Extract product questions from the product page (e.g., skier height/weight)
	templateData.productQuestions = getProductQuestions();
	templateData.hasProductQuestions = templateData.productQuestions.length > 0;

	// Extract the info link URL from the product page (e.g., "Mihin tietoja tarvitaan?" link)
	const $infoLink = $('.product-questions .general-info-modal a');
	templateData.hasProductQuestionsInfoLink = $infoLink.length > 0;
	templateData.productQuestionsInfoLink = $infoLink.attr('href') || '';
	templateData.productQuestionsInfoLabel = $infoLink.text() || 'Lue lisää';

	// Fetch the info content for inline display in the C&C form
	if (templateData.hasProductQuestionsInfoLink) {
		$.ajax({
			url: templateData.productQuestionsInfoLink,
			method: 'GET',
			headers: { 'x-requested-with': 'XMLHttpRequest' },
			success: function (html) {
				// Sanitize: parse without executing scripts, then strip dangerous elements
				const $parsed = $('<div>').append($.parseHTML(html, document, false));
				$parsed.find('script, iframe, style, link, noscript, object, embed').remove();
				// Try to find the main content area
				const $content = $parsed.find('#intersport-page, .u-text-content, .content-wrapper, article, main').first();
				const $body = $content.length ? $content : $parsed;

				// Remove titles (h1, h2) from the fetched content
				$body.find('h1, h2').remove();

				// Extract the first paragraph as preview, rest as expandable detail
				const $firstParagraph = $body.find('p').first();
				templateData.productQuestionsInfoPreview = $firstParagraph.length ? $firstParagraph.prop('outerHTML') : '';
				$firstParagraph.remove();
				templateData.productQuestionsInfoContent = $body.html();

				// If the preview element is already in the DOM, populate it immediately
				const $existingPreview = $('.cc-product-questions__preview');
				if ($existingPreview.length && templateData.productQuestionsInfoPreview) {
					$existingPreview.html(templateData.productQuestionsInfoPreview);
				}
			}
		});
	}

	if (renderNow) {
		templateData.selectFirstOption = true;
		toggleReservationForm(false);
		updateProductData();
		resetErrors();
		getStoreBalances(true);
	}

	$(window).on('popstate', (e) => {
		if ($clickAndCollect.hasClass('reservation-form-visible')) {
			toggleReservationForm(false);
		} else {
			closeClickAndCollect();
		}
	});

	async function handleOrderProductClick(e) {
		e.preventDefault();

		if (!$html.hasClass('v4-product-click-and-collect-open')) {
			storeScrollPosition($window);
			toggleClickAndCollect(true);
		}
		isActived = true;

		const reservationData = $(this)
			.closest('.click-and-collect-stores-list-item, .store-item')
			.data();
		const reservationDataUpdated = updateReservationData(
			reservationData.storeId,
			reservationData.storePrice,
			reservationData.bonusStorePrice,
			'order'
		);

		if (reservationDataUpdated) {
			// Check for free delivery when order button is clicked. The check is repeated
			// in refreshDeliveryFee() whenever the effective price changes (plussa
			// validation, C&P campaign), so the fee shown matches what checkout charges.
			await updateFreeDelivery(getEffectiveOrderPrice());

			renderData();
			toggleReservationForm(true, true);
		} else {
			getStoreBalances(true);
		}
		shippingFee(true);
	}

	/**
	 * clickAndCollectEvents
	 */
	function clickAndCollectEvents() {
		if (!renderNow) {
			$clickAndCollect.appendTo('#intersport-page');
		}

		// Bind events for the inline list
		$document.on(
			'click',
			'.store-availability .order-product-button',
			handleOrderProductClick
		);

		$clickAndCollect
			.on('click', '.product-click-and-collect-close', closeClickAndCollect)
			.on(
				'click',
				'.click-and-collect-stores-order-by-location-button',
				function () {
					if (templateData.geoLocation.enabled) {
						templateData.geoLocation.enabled = false;

						renderData();
					} else {
						resetErrors();

						getgeoLocation().always(function () {
							renderData();
						});
					}
				}
			)
			.on('change', '#click-and-collect-cities', function () {
				templateData.selectedCity = $(this).val();

				resetErrors();
				updateStoresData();
				renderData();
			})
			.on('click', '.reserve-product-button', function () {
				const reservationData = $(this)
					.closest('.click-and-collect-stores-list-item')
					.data();
				const reservationDataUpdated = updateReservationData(
					reservationData.storeId,
					reservationData.storePrice,
					reservationData.bonusStorePrice,
					'collect'
				);
				if (reservationDataUpdated) {
					renderData();
					toggleReservationForm(true);
				} else {
					getStoreBalances(true);
				}
				shippingFee(false);
			})
			.on('click', '.order-product-button', handleOrderProductClick)
			.on('click', '.click-and-collect-reservation-close', function () {
				closeClickAndCollect();
			})
			.on(
				'keyup invalid',
				'.click-and-collect-reservation-form input',
				function () {
					const $this = $(this);
					$this.toggleClass('invalid', $this.is(':invalid'));
				}
			)
			.on('submit', '.click-and-collect-reservation-form', function (e) {
				processReservationForm(e);
			})
			.on(
				'change',
				'.click-and-collect-reservation-form input[name="shipping"]',
				function () {
					setOnlinePayment();
					if (parseInt($(this).val()) === 1) {
						setShipping();
						$('.shipping-fee').removeClass('hidden');
						if (hasActiveClickAndCollectSale) {
							$('.plussa-campaign-info').removeClass('hidden');
						}
					} else {
						$('.shipping-fee').addClass('hidden');
						setCollecting();
						if (hasActiveClickAndCollectSale) {
							$('.plussa-campaign-info').addClass('hidden');
						}
					}
					updateCampaigns();
					if (hasActiveClickAndCollectSale) {
						setCampaignSale();
					}
				}
			)
			.on(
				'change',
				'.click-and-collect-reservation-form input[name="shipment_type"]',
				function () {
					deliveryFee();
					updateShippingFeeText();
				}
			)
			.on(
				'change',
				'.click-and-collect-reservation-form input[name="online_payment"]',
				setOnlinePayment
			)
			.on('click', '.cc-product-questions__toggle', function (e) {
				e.preventDefault();
				const $questions = $(this).closest('.cc-product-questions');
				const $detail = $questions.find('.cc-product-questions__detail');

				// Toggle the remaining content
				$detail.toggleClass('hidden');

				// Populate detail content on first open if available
				if (!$detail.hasClass('hidden') && !$detail.data('loaded') && templateData.productQuestionsInfoContent) {
					$detail.html(templateData.productQuestionsInfoContent);
					$detail.data('loaded', true);
				}

				// Update toggle text
				const isExpanded = !$detail.hasClass('hidden');
				$(this).text(isExpanded ? 'Näytä vähemmän' : 'Lue lisää');
			})
			.on(
				'change',
				'.click-and-collect-reservation-form input[name="kplussa_number"]',
				async function () {
					updateCampaigns();
					await checkIfUserHasValidPlussaCard();
					if (hasActiveClickAndCollectSale && plussaSale) {
						// setCampaignSale() also refreshes the delivery fee
						await setCampaignSale();
					} else {
						// No plussa campaign, but a bonus price may still apply
						await refreshDeliveryFee({ validatePlussa: false });
					}
				}
			);

		/*.on('change', '.click-and-collect-reservation-form input[name="shipping"]', function() {
				setOnlinePayment();
				if ($(this).val() == 1) {
					setShipping();
				} else {
					setCollecting();
				}
				if (hasActiveClickAndCollectSale) {
					setCampaignSale();
				}
			});*/

		// Close c&c by clicking outside it or outside the product form
		$document.on('click', function (e) {
			if (
				$clickAndCollect.hasClass('transition-done') &&
				!$(e.target).closest(
					'.v4-product-click-and-collect, .click-and-collect-stores-order-by-location-button, .reserve-product-button, .order-product-button, .product-colors, .product-sizes, .text-show-more'
				).length &&
				!renderNow
			) {
				closeClickAndCollect();
			}
		});
	}

	function shippingFee(active = false) {
		if (active) {
			$('.shipping-fee').removeClass('hidden');
			if (hasActiveClickAndCollectSale) {
				$('.plussa-campaign-info').removeClass('hidden');
			}
		} else {
			$('.shipping-fee').addClass('hidden');
			if (hasActiveClickAndCollectSale) {
				$('.plussa-campaign-info').addClass('hidden');
			}
		}
		if (hasActiveClickAndCollectSale) {
			// setCampaignSale() also refreshes the delivery fee
			setCampaignSale();
		} else if (active) {
			refreshDeliveryFee();
		}
	}

	/**
	 * Calculate the price the backend will use for the delivery fee of a shipped
	 * C&P order. Mirrors processReservationItems() in the click-and-collect Stage module:
	 * 1. store price
	 * 2. bonus price, if the user has a validated K-Plussa number and it is lower
	 * 3. best C&P sale campaign the user is eligible for, applied on top
	 *
	 * @returns {Number} effective price, 0 if there is no reservation
	 */
	function getEffectiveOrderPrice() {
		const item = templateData.reservation?.items?.[0];
		if (!item) return 0;

		let price = parseFloat(templateData.reservation.storePrice || item.price) || 0;

		const bonusPrice = parseFloat(item.bonusPrice) || 0;
		if (plussaCardValidated && bonusPrice > 0 && bonusPrice < price) {
			price = bonusPrice;
		}

		if (hasActiveClickAndCollectSale) {
			const eligibleCampaigns = validCNPCampaigns.filter((campaign) => {
				if (campaign.campaignType === 'plussa') return plussaCardValidated;
				if (campaign.campaignType === 'club') {
					return !!userInfo && parseInt(userInfo.activated) === 1;
				}
				return true;
			});
			const bestCampaign = findBestSaleCampaign(eligibleCampaigns);
			if (bestCampaign) {
				const basePrice =
					bestCampaign.campaignType === 'fromNormalPrice'
						? templateData.retailPrice
						: price;
				price = parseFloat(
					(basePrice * (1 - (bestCampaign.salePercentage || 0))).toFixed(2)
				);
			}
		}

		return price;
	}

	/**
	 * Ask the backend whether the given price qualifies for a free delivery campaign
	 * and update the shipment prices accordingly. Only done for logged in users, as
	 * the free delivery campaigns are club benefits.
	 *
	 * @param {Number} price
	 */
	async function updateFreeDelivery(price) {
		if (!(price > 0 && userInfo)) return;
		if (price === lastFreeDeliveryPrice) return;

		const seq = ++freeDeliveryLookupSeq;

		// Reset first: the price may have gone back above the free delivery limit, and a
		// failed lookup must fall back to the regular prices rather than a stale free one.
		shipmentTypes.posti = { ...SHIPMENT_PRICES.posti };
		for (const shipmentType of customShipmentTypes) {
			shipmentTypes[shipmentType.id] = {
				default: shipmentType.default,
				club: shipmentType.club,
			};
		}
		lastFreeDeliveryPrice = null;

		try {
			const freeDeliveriesUrl = '/stage-ajax/freeDeliveries';
			const freeDeliveryReq = await fetch(`${freeDeliveriesUrl}?price=${price}`, {
				method: 'GET',
			});
			const freeDelivery = await freeDeliveryReq.json();

			// A newer lookup was started while this one was in flight; let it commit instead
			if (seq !== freeDeliveryLookupSeq) return;
			lastFreeDeliveryPrice = price;

			if (freeDelivery && freeDelivery.methods) {
				if (Array.isArray(window.ccShipmentTypes)) {
					for (const method of freeDelivery.methods) {
						shipmentTypes[method] = {
							...shipmentTypes[method],
							club: 0,
						};
					}
				} else {
					shipmentTypes.posti.club = 0;
				}
			}
		} catch (error) {
			console.error('Error fetching free deliveries:', error);
		}
	}

	/**
	 * Update the fees shown in the reservation form: the "Toimituskulut" row for the
	 * selected shipment type (or the default fee when none is selected yet) and the
	 * price of each shipment type option, which the template only renders once.
	 */
	function updateShippingFeeText() {
		const { shipmentFee, deliveryFee: defaultFee } = templateData.reservation || {};
		if (!shipmentFee) return;

		const shipmentType = $('input[name="shipment_type"]:checked').val();
		let price = defaultFee;
		if (shipmentType === 'nouto') {
			price = 0;
		} else if (shipmentType && shipmentFee[shipmentType] !== undefined) {
			price = shipmentFee[shipmentType];
		}
		$('dd.shipping-fee').text(formatPrice(price));

		$('.click-and-collect-shipment-type input[name="shipment_type"]').each(
			function () {
				const fee = shipmentFee[this.value];
				if (fee === undefined) return;
				$(this)
					.closest('label')
					.find('.price')
					.text(`(hinta ${formatPrice(fee)})`);
			}
		);
	}

	/**
	 * Re-check free delivery with the current effective price and update the fee shown.
	 *
	 * @param {Object} [options]
	 * @param {Boolean} [options.validatePlussa=true] Validate a not yet validated K-Plussa
	 *   number first when a bonus price exists (e.g. number prefilled from user info).
	 */
	async function refreshDeliveryFee({ validatePlussa = true } = {}) {
		const item = templateData.reservation?.items?.[0];
		if (!item) return;
		if (validatePlussa && !plussaCardValidated && parseFloat(item.bonusPrice) > 0) {
			await checkIfUserHasValidPlussaCard();
		}
		await updateFreeDelivery(getEffectiveOrderPrice());
		deliveryFee();
		updateShippingFeeText();
	}

	function setShipping() {
		setRequiredFields(true);
		$('.click-and-collect-reservation-title').text('Vahvista tilaus');
		$('.shipping-disclaimer').removeClass('hidden');
		$('.click-and-collect-reservation-form .form-submit button').text('Tilaa');
		$(
			'.click-and-collect-reservation-form *[name="accepted_privacy_policy]'
		).prop('required', true);
		const $paymentInput = $('.click-and-collect-payment-method')
			.removeClass('hidden')
			.find('input[name="online_payment"]');
		if (!$paymentInput.is(':checked')) {
			$paymentInput.first().prop('checked', true);
		}
		setOnlinePayment();
	}

	function setOnlinePayment() {
		const paymentMethod = $('input[name=online_payment]:checked').val();
		if (templateData.reservation.order && paymentMethod) {
			$('input[name=stage-payment-provider]').prop('checked', false);
			$(`.payment-method-${paymentMethod}`).find('input').prop('checked', true);
		}
	}

	/**
	 * @function checkIfUserHasValidPlussaCard
	 * Makes a server-side validation of the plussa card number possibly entered by the user.
	 * @returns {boolean} true if user has a valid plussa card, false otherwise
	 */
	async function checkIfUserHasValidPlussaCard() {
		// Get plussa number value from the form
		const selector =
			'.click-and-collect-reservation-form input[name="kplussa_number"]';
		const plussaInput = document.querySelector(selector);
		if (!plussaInput) {
			plussaCardValidated = false;
			return false;
		}

		let cardNumber = plussaInput.value;
		if (!cardNumber) {
			plussaCardValidated = false;
			return false;
		}

		// Get plussa prefix from plussa input's data attribute
		const plussaPrefix = String(plussaInput.dataset.plussaPrefix);
		if (plussaPrefix && cardNumber && cardNumber.indexOf(plussaPrefix) !== 0) {
			cardNumber = plussaPrefix + cardNumber;
		}

		// Validate each card number on the server once; a failed request is treated as
		// "not validated" and retried on the next call instead of rejecting the caller.
		if (!plussaValidationCache.has(cardNumber)) {
			plussaValidationCache.set(
				cardNumber,
				fetch('/stage-ajax/ccPlussaSale', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
						Accept: 'application/json',
					},
					body: `cardNumber=${cardNumber}`,
				})
					.then((response) => response.json())
					.then(({ result }) => parseInt(result) === 1)
					.catch((error) => {
						console.error('Error validating K-Plussa card:', error);
						plussaValidationCache.delete(cardNumber);
						return false;
					})
			);
		}
		const resultInt = await plussaValidationCache.get(cardNumber);
		plussaCardValidated = resultInt;

		const hasBonusPrice = !!templateData.reservation?.items?.[0]?.bonusPrice;
		if (resultInt && (plussaSale || hasBonusPrice)) {
			$('.plussa-card-validated').removeClass('hidden');
			$('dd.prices').addClass('plussa-card-validated');
		}
		return resultInt;
	}

	/**
	 * @function setCampaignSale
	 * This function does 2 things:
	 * 1. Toggle the visibility of each sale campaign info box ("Liity klubiin ja saat 20% alennuksen").
	 *    - If the user has entered a valid plussa number, hide the plussa sale info box.
	 *    - If the user is logged in, hide the club sale info box.
	 * 2. Update the price of the product displayed above the form.
	 */
	async function setCampaignSale() {
		const $form = $('.click-and-collect-reservation-form');
		const shipping = $form.find('input[name="shipping"]').val();
		const orderType =
			shipping && parseInt(shipping) === 1 ? 'order' : 'collect';

		/**
		 * Step 1: Check which sales are active, and which info boxes should be shown.
		 */

		// Check plussa sale
		let userHasValidPlussaCard = false;
		if (plussaSale && orderType === 'order') {
			userHasValidPlussaCard = await checkIfUserHasValidPlussaCard();
		}
		// const plussaSalePriceIsActivated = plussaSale && userHasValidPlussaCard && orderType === 'order';
		const showPlussaSaleInfoBox =
			plussaSale && !userHasValidPlussaCard && orderType === 'order';

		// Check club sale
		// const clubSalePriceIsActivated = clubSale && userInfo && orderType === 'order';
		const showClubSaleInfoBox = clubSale && !userInfo && orderType === 'order';

		// Check brand sale
		// const brandSalePriceIsActivated = brandSale && orderType === 'order';
		const showBrandSaleInfoBox = brandSale && orderType === 'order';

		// From normal price sale
		// const fromNormalPriceSalePriceIsActivated = normalPriceSale && orderType === 'order';
		const showFromNormalPriceSaleInfoBox =
			normalPriceSale && orderType === 'order';

		// Toggle visibility of sale info boxes
		$('.cc-info-box.plussa-campaign-info').toggleClass(
			'hidden',
			!showPlussaSaleInfoBox
		);
		$('.cc-info-box.sale-login').toggleClass('hidden', !showClubSaleInfoBox);
		$('.cc-info-box.brand-sale-info').toggleClass(
			'hidden',
			!showBrandSaleInfoBox
		);
		$('.cc-info-box.from-normal-price-sale-info').toggleClass(
			'hidden',
			!showFromNormalPriceSaleInfoBox
		);

		// Toggle visibility of plussa card validation
		$('.plussa-card-validated').toggleClass('hidden', !userHasValidPlussaCard);

		/**
		 * Step 2: Calculate the currently active price of the product and update it
		 */

		// Calculate current active price for user
		/*
		const bestActiveSalePercentage = Math.max(
			plussaSalePriceIsActivated ? templateData.saleCampaigns.plussa?.salePercentage || 0 : 0,
			clubSalePriceIsActivated ? templateData.saleCampaigns.club?.salePercentage || 0 : 0,
			brandSalePriceIsActivated ? templateData.saleCampaigns.brand?.salePercentage || 0 : 0,
			fromNormalPriceSalePriceIsActivated ? templateData.saleCampaigns.fromNormalPrice?.salePercentage || 0 : 0
		); */
		const bestCampaigns = findBestSaleCampaign(validCNPCampaigns);

		const bestActiveSalePercentage = (
			(bestCampaigns?.salePercentage || 0) * 100
		).toFixed(0);
		const originalPrice = templateData.reservation.items[0].price;

		const salePrice = parseFloat(
			(bestCampaigns.campaignType === 'fromNormalPrice'
				? templateData.retailPrice
				: templateData.reservation.items[0].price) *
				(1 - bestActiveSalePercentage / 100)
		).toFixed(2);
		templateData.salePrice = salePrice;
		const originalPriceFormatted = parseFloat(originalPrice).toFixed(2);

		// Update price text
		if (originalPrice !== salePrice) {
			const priceText = `<span style="text-decoration: line-through;">${originalPriceFormatted} €</span> <span style="color: #e60b0b;">${salePrice} €</span>`;
			// Update plussa card validation texts
			const plussaCampaignIsBest =
				bestActiveSalePercentage ===
				templateData.saleCampaigns.plussa?.salePercentage;
			if (plussaCampaignIsBest) {
				$('.plussa-card-validated .price-info').html(
					`Tuotteen hinta: ${priceText}`
				);
			} else {
				$('.click-and-collect-reservation dl dt:contains("Hinta") + dd').html(
					priceText
				);
			}
		} else {
			$('.click-and-collect-reservation dl dt:contains("Hinta") + dd').html(
				originalPriceFormatted + ' €'
			);
		}

		/**
		 * Step 3: The delivery fee depends on the discounted price (INTERCONT-7379)
		 */
		if (orderType === 'order') {
			await refreshDeliveryFee();
		}
	}

	function setCollecting() {
		setRequiredFields(false);
		$('.click-and-collect-reservation-title').text('Vahvista varaus');
		$('.click-and-collect-reservation-form .form-submit button').text('Varaa');
		$(
			'.click-and-collect-reservation-form *[name="accepted_privacy_policy]'
		).prop('required', false);
		$('.shipping-disclaimer').addClass('hidden');
		$('.click-and-collect-payment-method').addClass('hidden');
	}

	function setRequiredFields(isRequired) {
		const $requiredFields = $('.click-and-collect-reservation-form').find(
			'.required-for-shipping'
		);
		$requiredFields.prop('required', isRequired);
		$requiredFields.each(function () {
			const $label = $(this).closest('.form-input').find('label');
			const labelText = isRequired
				? $label.text().replace(' *', '') + ' *'
				: $label.text().replace(' *', '');
			$label.text(labelText);
		});
	}

	const paymentHtml = {};

	function showPaymentForm(shopId) {
		if (!paymentHtml[shopId]) {
			let url = '/stage-ajax/getPaymentForm';
			if (shopId) {
				url += '?merchantId=' + shopId;
			}
			getToken()
				.then((token) => Promise.resolve($.post(url, { token })))
				.then((markup) => injectPayment(shopId, markup));
		} else {
			injectPayment(shopId);
		}
	}

	function injectPayment(shopId, markup) {
		if (markup !== undefined) {
			paymentHtml[shopId] = markup;
		}
		$('.click-and-collect-payment-form').remove();
		if (paymentHtml[shopId]) {
			$('.click-and-collect-payment-method')
				.append(paymentHtml[shopId])
				.find('input[name="stage-payment-provider"]')
				.first()
				.prop('checked', true);
			$('.click-and-collect-payment-form').addClass('hidden');
		}
	}

	function openClickAndCollect() {
		// DEPRECATED: Free deliveries check moved to when the order button is clicked
		// Free delivery eligibility should be determined at order time, not when opening the panel

		if ($productForm.find('[name="ean"]:checked').length) {
			storeScrollPosition($window);
			toggleClickAndCollect(true);
			if (!isActived) {
				isActived = true;
				$productForm.find('[name="ean"]:checked').trigger('change');
				getgeoLocation().always(function () {
					renderData();
				});
			} else if (window.user && window.user.loggedIn && !userInfo) {
				// User has logged in via ajax, get full user info
				const userPromise =
					userInfo === null
						? getUser('me').then((res) => {
							if (res.user) {
								userInfo = res.user;
							}
						  })
						: Promise.resolve();

				Promise.all([userPromise]).then(() => {
					if (userInfo) {
						renderData();

						// Update user info for form
						const $form = $clickAndCollect.find(
							'.click-and-collect-reservation-form'
						);
						updateUserInfo($form);

						// Show shipping fee
						shippingFee(true);
					}
				});
			}
			if (typeof history !== 'undefined') {
				// push empty history entry to allow back button to close the panel
				history.pushState(null, '', '');
			}
			return true;
		}
		return false;
	}

	function closeClickAndCollect() {
		toggleClickAndCollect(false);
		restoreScrollPosition($window);
	}

	/**
	 * productFormEvents
	 */
	function productFormEvents() {
		$productForm
			.on('click', '.click-and-collect-button:not(.disabled), .view-all-link', function (e) {
				e.preventDefault();
				if ($productForm.find('[name="ean"]:checked').length) {
					//window.location.hash = 'saatavuus';
					toggleReservationForm(false);
					openClickAndCollect();
				}
			})
			.on('change', '[name="color"]', function () {
				if (isActived) {
					toggleReservationForm(false);
					updateProductData();
					getStoreBalances(true);
					resetErrors();
				}
			})
			.on('change', '[name="ean"]', function () {
				if (isActived) {
					toggleReservationForm(false);
					updateProductData();
					getStoreBalances(true);
					resetErrors();
				} else {
					// We still want to update on-page data even if modal is not active
					updateProductData();
					if (templateData.disableCc) {
						$('.store-availability').empty();
					} else {
						addInlineStoreLoader();
						getgeoLocation().always(function () {
							getStoreBalances(true);
						});
					}
				}
			})
			.on('click', '[data-toggle="modal"]', function () {
				toggleClickAndCollect(false);
			});
	}

	function infoTextAccordion() {
		const $showMore = $('.text-show-more');
		$showMore.on('click', 'a', (e) => {
			e.preventDefault();
			const $toggleLink = $(e.target);
			const $linkContainer = $toggleLink.parent();
			const show = $toggleLink.hasClass('show-text');

			if (show) {
				$linkContainer.find('p').show();
				$linkContainer.find('.show-text').hide();
				$linkContainer.find('.close-text').show();
			} else {
				$linkContainer.find('p').hide();
				$linkContainer.find('.show-text').show();
				$linkContainer.find('.close-text').hide();
			}
		});
	}

	/**
	 * getStoreBalances
	 *
	 * @param {Boolean} updateDataAndRender
	 *
	 * @return {Promise}
	 */
	function getStoreBalances(updateDataAndRender) {
		const ttl = 60;
		let colorBalances = storeBalances[templateData.product.sapTitlenumber]
			? storeBalances[templateData.product.sapTitlenumber][
				templateData.product.colorCode
			  ]
			: null;

		if (
			!colorBalances ||
			(colorBalances.stores && !colorBalances.stores.length) ||
			getTimestamp() - colorBalances.timestamp > ttl
		) {
			if (getLoader('stores') && isActived) {
				jqXHR?.abort();
			}

			setLoader('stores', true);

			const shopPromise = !shopsLoaded
				? getShops().then((res) => {
					shops = res.shops;
					shopsLoaded = true;
				  })
				: Promise.resolve();

			const userPromise =
				userInfo === null
					? getUser('me').then((res) => {
						if (res.user) {
							userInfo = res.user;
						}
					  })
					: Promise.resolve();

			Promise.all([shopPromise, userPromise]).then(() => {
				jqXHR = $.ajax({
					cache: true,
					data: {
						color: templateData.product.colorCode,
						sap_titlenumber: templateData.product.sapTitlenumber,
					},
					dataType: 'json',
					method: 'get',
					timeout: 30000,
					url: '/stage-ajax/storeBalances/',
				})
					.done(function (response, status, xhr) {
						if (response.items) {
							processStoreBalances(
								response.items,
								response.colorCode,
								response.sapTitlenumber
							);
						} else {
							handleStoreBalanceErrors(xhr);
						}

						if (response.disableCC) {
							//templateData.disableCC = true;
							//templateData.disableCCTitle = response.disableCCTitle;
							//templateData.disableCCText = response.disableCCText;
						}

						if (updateDataAndRender) {
							updateStoresData();
							renderData();
						}
					})
					.fail(handleStoreBalanceErrors)
					.always(function () {
						setLoader('stores', false);
					});
			});
			colorBalances = jqXHR;
		} else if (updateDataAndRender) {
			updateStoresData();
			renderData();
		}

		return $.when(colorBalances);
	}

	/**
	 * processStoreBalances
	 *
	 * @param {Array} stores
	 * @param {String} colorCode
	 */
	function processStoreBalances(stores, colorCode, sapTitlenumber) {
		storeBalances[sapTitlenumber] = {};
		storeBalances[sapTitlenumber][colorCode] = {
			timestamp: getTimestamp(),
		};

		storeBalances[sapTitlenumber][colorCode].stores = $.map(
			stores,
			function (store) {
				if (shops[store.shop]) {
					if (typeof store.storeData === 'undefined') {
						store.id = store.shop;
						delete store.shop;
						store.storeData = shops[store.id] || {};
					}
					return store;
				}
			}
		).sort(function (a, b) {
			if (a.storeData.city === b.storeData.city) {
				return a.storeData.name < b.storeData.name
					? -1
					: a.storeData.name > b.storeData.name
						? 1
						: 0;
			}
			return a.storeData.city < b.storeData.city
				? -1
				: a.storeData.city > b.storeData.city
					? 1
					: 0;
		});
	}

	/**
	 * handleStoreBalanceErrors
	 *
	 * @param {Object} xhr
	 */
	function handleStoreBalanceErrors(xhr) {
		const response =
			xhr && xhr.statusText !== 'abort' ? xhr.responseJSON : false;

		if (response) {
			storeBalances[response.sapTitlenumber] = {};
			storeBalances[response.sapTitlenumber][response.colorCode] = {
				error: response.error,
			};
		}
	}

	/**
	 * updateProductData
	 */
	function updateProductData() {
		const colorVisible = $productForm.find('.product-colors').data('visible');
		const $color = $productForm.find(
			'[name="color"]:checked, [type="hidden"][name*="color"][data-page-variant="true"]'
		);
		const sizeVisible = $productForm.find('.product-sizes').data('visible');
		const $size = $productForm.find('[name="ean"]:checked');
		const sapTitlenumber =
			$size.data('sap-titlenumber') || $productForm.data('sapTitlenumber');
		const flex = $size.data('ice-hockey-flex') || null;
		const hand = $size.data('hand') || null;

		templateData.product = {
			color: parseInt(colorVisible) === 1 ? $color.data('name') : '',
			colorCode: $color.val(),
			ean: $size.closest(
				'.product-sizes-list[data-color="' + $color.val() + '"]'
			).length
				? $size.val()
				: '',
			name:
				$productForm.data('brandName') + ' ' + $productForm.data('productName'),
			sapTitlenumber: sapTitlenumber,
			size: parseInt(sizeVisible) === 1 ? $size.data('name') : '',
			image: $color
				.closest('.product-colors-list-item')
				.find('img')
				.attr('src')
				.replace('c=system_150', 'c=system_1024x'),
			canShip:
				!$productForm.data('specialDelivery') || customShipmentTypes.length,
			specialDelivery: $productForm.data('enable-cp-for-special-delivery'), //enable-cp-for-special-delivery
			isIceHockeyStick: !!flex,
			flex: flex,
			hand: hand,
		};

		templateData.stores = [];
		templateData.cities = [];
		templateData.hasStores = false;
		templateData.sizeSelected = !!templateData.product.ean;
	}

	/**
	 * updateStoresData
	 */
	function updateStoresData() {
		const colorBalances = storeBalances[templateData.product.sapTitlenumber]
			? storeBalances[templateData.product.sapTitlenumber][
				templateData.product.colorCode
			  ]
			: null;

		if (colorBalances) {
			if (!colorBalances.error) {
				const uniqueCities = [];

				templateData.cities = [];

				templateData.stores = $.map(colorBalances.stores, function (store) {
					const storeBalance = store.balances.filter(function (balanceItem) {
						return (
							!balanceItem.ccDisabled &&
							templateData.product &&
							templateData.product.ean === balanceItem.ean &&
							balanceItem.balance > 0
						);
					});

					store.canShip =
						(store.hasOnlinePayment || store.storeData.prepayment) &&
						(templateData.product.canShip ||
							templateData.product
								.specialDelivery) /*&& parseFloat(store.price) >= 50*/;
					store.specialDelivery = templateData.product.specialDelivery;

					if (storeBalance.length) {
						if (uniqueCities.indexOf(store.storeData.city) === -1) {
							uniqueCities.push(store.storeData.city);
							templateData.cities.push({ name: store.storeData.city });
						}

						const lowBalanceThreshold = templateData.disableCampaignCc ? 3 : 2;
						storeBalance[0].hasLowBalance =
							storeBalance[0].balance <= lowBalanceThreshold;
						const item = $.extend({}, store, {
							balanceData: storeBalance[0],
						});
						if (item.balanceData.forceEnableCc) {
							delete item.disableCc;
						}
						return item;
					}
				});

				// Select first of the options
				if (templateData.selectFirstOption && templateData.cities.length > 0) {
					templateData.selectedCity = templateData.cities[0].name;
					templateData.selectFirstOption = false;
				}

				const foundInStores = templateData.stores.length;
				const foundInStoresText = `Tuote on saatavilla <a href="#" class="click-and-collect-button">${foundInStores} kaupassa.</a> Katso kauppasaatavuus nähdäksesi tarkemmat tiedot.`;
				$('.product-available-in-stores').find('span').html(foundInStoresText);

				templateData.hasStores = !!templateData.stores.length;
			} else {
				setError('stores', colorBalances.error);
			}
		}
	}

	/**
	 * filterStoresbyCity
	 *
	 * @param {String} [city]
	 */
	function filterStoresbyCity(city = templateData.selectedCity) {
		if (city) {
			const cityStores = templateData.stores.filter(function (store) {
				return !city || city === store.storeData.city;
			});

			$.each(templateData.cities, function (i, cityItem) {
				if (city === cityItem.name) {
					cityItem.selected = true;
					return false;
				}
			});

			if (cityStores.length) {
				templateData.stores = cityStores;
				setError('cities', false);
			} else {
				setError('cities', true);
			}
		}
	}

	/**
	 * getgeoLocation
	 *
	 * @return {Promise}
	 */
	function getgeoLocation() {
		const dfd = $.Deferred();

		setLoader('geoLocation', true);

		navigator.geolocation.getCurrentPosition(dfd.resolve, dfd.reject, {
			enableHighAccuracy: true,
			timeout: 5000,
			maximumAge: 60000,
		});

		dfd
			.done(function (position) {
				if (position) {
					templateData.geoLocation.enabled = true;
					templateData.geoLocation.lat = position.coords.latitude;
					templateData.geoLocation.lon = position.coords.longitude;
				} else {
					handleGeoLocationErrors(position);
				}
			})
			.fail(handleGeoLocationErrors)
			.always(function () {
				setLoader('geoLocation', false);
			});

		return dfd.promise();
	}

	/**
	 * handleGeoLocationErrors
	 *
	 * @param {Object} error
	 */
	function handleGeoLocationErrors(error) {
		$('.click-and-collect-stores-order-by-location-button')
			.addClass('hidden')
			.hide();
		/*if (error.code === 1) {
			setError('geoLocationBlockedByUser', true);
		} else {
			setError('geoLocation', true);
		}*/
	}

	/**
	 * orderStoresByLocation
	 *
	 * @param {Number} [lat]
	 * @param {Number} [lon]
	 */
	function orderStoresByLocation(
		lat = templateData.geoLocation.lat,
		lon = templateData.geoLocation.lon
	) {
		if (templateData.geoLocation.enabled) {
			$.each(templateData.stores, function (i, store) {
				store.distance = Math.round(
					calculateDistance(
						lat,
						lon,
						Number(store.storeData.lat),
						Number(store.storeData.long)
					)
				);
			});

			templateData.stores = templateData.stores.sort(function (a, b) {
				return a.distance < b.distance ? -1 : a.distance > b.distance ? 1 : 0;
			});
		}
	}

	/**
	 * updateReservationData
	 *
	 * @param {String} storeId
	 * @param {Number} price
	 *
	 * @return {Boolean} allowReservation
	 */
	function updateReservationData(storeId, price, bonusPrice, type) {
		const isValidReservation = templateData.stores.some(function (store) {
			return (
				store.id === storeId &&
				price > 0 &&
				(!store.disableCc || templateData.vmEnableCp)
			);
		});

		const store = templateData.stores.find((store) => store.id === storeId);

		if (isValidReservation) {
			// New reservation: the Plussa number is re-entered (or prefilled) in the new
			// form and the free delivery lookup must start from the new store price.
			plussaCardValidated = false;
			lastFreeDeliveryPrice = null;

			templateData.reservation = {
				items: [
					{
						amount: 1,
						price: price,
						bonusPrice: bonusPrice,
						ean: templateData.product.ean,
						name: templateData.product.name,
						color: templateData.product.color,
						size: templateData.product.size,
						image: templateData.product.image,
						isIceHockeyStick: templateData.product.isIceHockeyStick,
						flex: templateData.product.flex,
						hand: templateData.product.hand,
					},
				],
				store: storeId && shops[storeId] ? shops[storeId].name : '',
				storeId: storeId.charAt(0) === 't' ? storeId.substring(1) : storeId,
				extranet_users_uuid: '',
				shop: store.storeData,
				hasOnlinePayment:
					store && store.hasOnlinePayment && store.storeData.online_payment,
				canShip: store.canShip,
				specialDelivery: store.specialDelivery,
				// Save the store price separately to be used for delivery fee calculation
				storePrice: price,
			};
			updateCampaigns();

			if (typeof type !== 'undefined') {
				templateData.reservation.shop.termsLink =
					templateData.reservation.shop.termsLink.indexOf('?type') === -1
						? `${templateData.reservation.shop.termsLink}?type=${type}`
						: templateData.reservation.shop.termsLink.replace(
							/type=(.*)/g,
							`type=${type}`
						  );
				templateData.reservation.shop.dataProtectionLink =
					templateData.reservation.shop.dataProtectionLink.indexOf('?type') ===
					-1
						? `${templateData.reservation.shop.dataProtectionLink}?type=${type}`
						: templateData.reservation.shop.dataProtectionLink.replace(
							/type=(.*)/g,
							`type=${type}`
						  );
				templateData.reservation[type] = true;
			}
		}

		return isValidReservation;
	}

	function updateUserInfo($form) {
		if (userInfo) {
			const plussaPrefix = String(
				$form.find('input[name="kplussa_number"]').data('plussa-prefix')
			);
			const usersPlussaNumber = userInfo.kplussa_number;

			// if userInfo contains kplussa_number remove plussaPrefix from the beginning if it's included
			if (
				usersPlussaNumber &&
				plussaPrefix &&
				usersPlussaNumber.indexOf(plussaPrefix) === 0
			) {
				// remove plussaPrefix from the beginning
				const plussaWithoutPrefix = usersPlussaNumber.slice(
					plussaPrefix.length,
					usersPlussaNumber.length
				);
				userInfo.kplussa_number = plussaWithoutPrefix;
			}

			$form.serializeArray().forEach((field) => {
				const $field = $form.find(`*[name="${field.name}"]`);

				// Prefill visible customer fields only. Hidden fields (shop_id, shipping,
				// stage_payment, extranet_users_uuid, tokens) describe the order and are
				// filled by the backend; they must never be overwritten from the profile.
				if ($field.is('input[type="hidden"]')) {
					return;
				}

				if (userInfo[field.name]) {
					$field.val(userInfo[field.name]);
					if (field.name === 'kplussa_number') {
						checkIfUserHasValidPlussaCard();
					}
				}
			});
		}
	}

	/**
	 * toggleReservationForm
	 * @param {Boolean} showForm
	 */
	function toggleReservationForm(showForm, shipping) {
		if (typeof showForm !== 'undefined') {
			const $scrollArea = $clickAndCollect.find(
				'.click-and-collect-scroll-area'
			);

			if (showForm) {
				storeScrollPosition($scrollArea);
				$clickAndCollect.addClass('reservation-form-visible');

				const $form = $clickAndCollect.find(
					'.click-and-collect-reservation-form'
				);
				updateUserInfo($form);

				if (templateData.reservation.hasOnlinePayment) {
					showPaymentForm(templateData.reservation.storeId);
				} else {
					$('.click-and-collect-payment-form').remove();
				}

				$scrollArea.scrollTop(0);
				if (typeof history !== 'undefined') {
					history.pushState(null, '', '');
				}
			} else {
				$clickAndCollect.removeClass('reservation-form-visible');
				restoreScrollPosition($scrollArea);
			}
		}
	}

	/**
	 * processReservationForm
	 *
	 * @param {Object} e
	 */
	function processReservationForm(e) {
		const $form = $clickAndCollect.find('.click-and-collect-reservation-form');
		const onlinePayment =
			parseInt($form.find('input[name="stage_payment"]').val()) === 1;
		const $plussaInput = $form.find('input[name="kplussa_number"]');
		const plussaPrefix = String($plussaInput.data('plussa-prefix'));

		if (!onlinePayment) {
			e.preventDefault();
		} else {
			return;
		}

		const $token = $form.find('input[name$="token"]');
		const $submit = $form.find('button[type="submit"]');
		const formErrorMessage = $form.data('formErrorText');

		$submit.prop('disabled', true);

		clearReservationFormMessages();
		addReservationFormLoader();

		if ($token.val()) {
			loggedIn = userInfo ? 1 : 0;

			// Collect product questions from the form
			const productQuestions = [];
			$form.find('.cc-product-questions__field').each(function () {
				const $field = $(this);
				const $input = $field.find('.cc-product-questions__input');
				const label = $input.data('label') || '';
				const unit = $input.data('unit') || '';
				const value = $input.val() || '';

				if (label && value) {
					productQuestions.push({ label, unit, value });
				}
			});

			// Build extraInformation with product questions for storage in extra_information DB field
			const extraInformation = {};
			if (productQuestions.length > 0) {
				extraInformation.productQuestions = productQuestions;
			}

			const data = $.extend(
				{
					items: templateData.reservation.items,
					loggedIn,
					extraInformation: Object.keys(extraInformation).length > 0 ? JSON.stringify(extraInformation) : undefined,
				},
				$form.serializeObject()
			);

			// if data containes kplussa_number add plussaPrefix to the beginning if it's missing
			if (
				data.kplussa_number &&
				data.kplussa_number.indexOf(plussaPrefix) !== 0
			) {
				data.kplussa_number = plussaPrefix + data.kplussa_number;
			}

			$.ajax({
				data,
				dataType: 'json',
				method: 'POST',
				timeout: 30000,
				url: '/stage-ajax/clickAndCollect/',
			})
				.done(function (response) {
					if (response && response.result === 1) {
						if (
							Object.prototype.hasOwnProperty.call(
								templateData.reservation,
								'store'
							)
						) {
							let storeName = templateData.reservation.store.trim();
							window.dataLayer.push({
								event: 'cncOrder',
								store: storeName,
							});
						}

						if (response.checkout) {
							$form.attr('action', response.checkout);
							$form.find('input[name="stage_payment"]').val('1');
							updateFormToken().then(() => $form.submit());
						} else {
							templateData.reservation.done = true;
							if (response.shipping) {
								templateData.reservation.shipping = true;
							}

							if (templateData.salePrice) {
								// There's a salePrice (club sale, plussa sale or brand sale). Update item price according to that.
								templateData.reservation.items[0].price =
									templateData.salePrice;
							}

							renderData();
							toggleReservationForm(true);
						}
					} else if (response && response.reason) {
						addReservationFormMessage(response.reason, true);
					} else {
						addReservationFormMessage(formErrorMessage, true);
					}
				})
				.fail(function (xhr) {
					addReservationFormMessage(formErrorMessage, true);
				})
				.always(function (response) {
					if (!response.checkout) {
						removeReservationFormLoader();
						$form.find('input[name$="token"]').val('');
						$submit.prop('disabled', false);
					}
				});
		} else {
			updateFormToken($form);
		}
	}

	/**
	 * setLoader
	 *
	 * @param {String} name
	 * @param {Boolean} state
	 */
	function setLoader(name, state) {
		if (name && typeof state !== 'undefined') {
			if (state) {
				templateData.loaders[name] = true;
			} else {
				delete templateData.loaders[name];
			}

			$clickAndCollect.toggleClass(
				'is-loading',
				!!Object.keys(templateData.loaders).length
			);
		}
	}

	/**
	 * getLoader
	 *
	 * @param {String} name
	 *
	 * @return {Boolean}
	 */
	function getLoader(name) {
		return templateData.loaders[name] || false;
	}

	/**
	 * addFormMessage
	 *
	 * @param {String}  msg
	 * @param {Boolean} isError
	 */
	function addReservationFormMessage(msg, isError) {
		clearReservationFormMessages();

		$('<div>', {
			class: 'click-and-collect-info-block' + (isError ? ' is-error' : ''),
			text: msg,
		}).appendTo(
			$clickAndCollect.find(
				'#click-and-collect-reservation-form-alert-container'
			)
		);
	}

	/**
	 * clearReservationFormMessages
	 */
	function clearReservationFormMessages() {
		$clickAndCollect
			.find('#click-and-collect-reservation-form-alert-container')
			.find('.click-and-collect-info-block')
			.remove();
	}

	/**
	 * Add spinner loader to the page
	 */
	function addReservationFormLoader() {
		removeReservationFormLoader();

		$('<div>', { class: 'click-and-collect-loader' })
			.append($('<div>', { class: 'spinner-loader-circle' }))
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle2' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle3' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle4' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle5' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle6' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle7' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle8' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle9' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle10' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle11' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle12' })
			)
			.appendTo(
				$clickAndCollect.find(
					'#click-and-collect-reservation-form-alert-container'
				)
			);
	}

	/**
	 * Add Remove loader to the page
	 */
	function removeReservationFormLoader() {
		$clickAndCollect
			.find('#click-and-collect-reservation-form-alert-container')
			.find('.click-and-collect-loader')
			.remove();
	}

	/**
	 * Add spinner loader to the inline store list
	 */
	function addInlineStoreLoader() {
		const $container = $('.store-availability');
		$container.empty();

		$('<div>', { class: 'click-and-collect-loader', style: 'margin: 20px auto; display: block;' })
			.append($('<div>', { class: 'spinner-loader-circle' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle2' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle3' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle4' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle5' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle6' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle7' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle8' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle9' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle10' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle11' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle12' }))
			.appendTo($container);
	}

	/**
	 * setError
	 *
	 * @param {String} name
	 * @param {Boolean} state
	 */
	function setError(name, state) {
		if (name && typeof state !== 'undefined') {
			templateData.errors[name] = state;
		}
	}

	/**
	 * resetErrors
	 */
	function resetErrors() {
		templateData.errors = {};
		renderData();
	}

	/**
	 * Get C&P campaigns that are currently active or will be active within a day.
	 * @returns {Object[]} An array of campaign objects.
	 */
	async function getCNPCampaigns() {
		return await fetch('/stage-ajax/getCNPCampaigns')
			.then((response) => response.json())
			.then((data) =>
				data.map((campaign) => ({
					...campaign,
					start: new Date(campaign.start),
					end: new Date(campaign.end),
				}))
			);
	}

	/**
	 * Check if a campaign is valid for the current product.
	 * @param {Object} campaign - The campaign object as returned by getCNPCampaigns.
	 * @param {Object} product - The product object, including properties category_type, category, subcategory, brand, campaignIds.
	 * @returns {Boolean} True if the campaign is valid for the product, false otherwise.
	 */
	function campaignIsValidForProduct(campaign, product) {
		if (!product || !campaign) return false;

		// Check if the campaign is active at the moment
		const now = new Date();
		if (
			!isValidDateObject(campaign.start) ||
			now < campaign.start || // campaign has not yet started, or start date missing/invalid
			!isValidDateObject(campaign.end) ||
			now > campaign.end // campaign has already ended, or end date missing/invalid
		) {
			return false;
		}

		// Check that category type of the campaign matches the product's type (clothing, shoe, accessory)
		if (
			campaign.saleCategoryTypes.length > 0 &&
			!campaign.saleCategoryTypes.includes(product.categoryType)
		) {
			return false;
		}

		// Check that product category of the campaign matches the product's category
		if (
			campaign.saleCategories.length > 0 &&
			!campaign.saleCategories.includes(product.category)
		) {
			return false;
		}

		// Check that product subcategory of the campaign matches the product's subcategory
		if (
			campaign.saleSubCategories.length > 0 &&
			!campaign.saleSubCategories.includes(product.subcategory)
		) {
			return false;
		}

		// Check that brand of the campaign matches the product's brand
		if (
			campaign.saleBrands.length > 0 &&
			!campaign.saleBrands.includes(product.brandName)
		) {
			return false;
		}

		// Check that product campaign id of the campaign matches the product's campaign id
		if (
			campaign.saleCampaignIds.length > 0 &&
			!isValidSaleCampaignProduct(campaign.saleCampaignIds, product.campaignIds)
		) {
			return false;
		}

		// Products belonging to a disabled campaign id are excluded from the sale campaign
		if (
			campaign.disabledSaleCampaignIds?.length > 0 &&
			isValidSaleCampaignProduct(
				campaign.disabledSaleCampaignIds,
				product.campaignIds
			)
		) {
			return false;
		}

		// If the campaign is disabled for all sale campaigns, then products with any campaign id are excluded from the sale campaign
		if (campaign.disabledForAllSaleCampaigns === true && String(product.campaignIds || '').length) {
			return false;
		}

		if (campaign.campaignType === 'fromNormalPrice') {
			if (
				!(
					product.retailPrice > 0 &&
					templateData?.reservation?.items?.[0]?.price > 0
				)
			) {
				return false;
			}

			const campaignSaleMultiplier = 1.0 - campaign.salePercentage;
			const activePrice = Number.parseFloat(
				templateData.reservation.items[0].price
			);
			const fromRetailPrice = product.retailPrice * campaignSaleMultiplier;

			if (fromRetailPrice > activePrice) {
				return false;
			}
		}

		return true;
	}

	/**
	 * toggleClickAndCollect
	 *
	 * @param {Boolean} show
	 */
	function toggleClickAndCollect(show = true) {
		if (show) {
			$clickAndCollect.one(utils.transitionDone(), function () {
				$clickAndCollect.addClass('transition-done');
			});
		} else {
			$clickAndCollect.removeClass('transition-done');
		}

		$html.toggleClass('v4-product-click-and-collect-open', show);
	}

	function deliveryFee() {
		const hasCustomShipmentTypes = customShipmentTypes.length ? true : false;

		templateData.reservation.hasCustomDelivery = hasCustomShipmentTypes;
		templateData.reservation.customDelivery = false;
		if (hasCustomShipmentTypes) {
			templateData.reservation.customDelivery = customShipmentTypes.map(
				(shipment) => {
					return {
						id: shipment.id,
						name: shipment.name,
						currentPrice:
							userInfo && parseInt(userInfo.activated) === 1
								? parseFloat(shipment.club).toFixed(2)
								: parseFloat(shipment.default).toFixed(2),
						priceClub: parseFloat(shipment.club).toFixed(2),
						priceDefault: parseFloat(shipment.default).toFixed(2),
					};
				}
			);
		}

		if (userInfo && parseInt(userInfo.activated) === 1) {
			// Default fee row follows the Posti price, which may be 0 with free delivery
			templateData.reservation.deliveryFee = templateData.reservation
				.specialDelivery
				? parseFloat(shipmentTypes.special.club).toFixed(2)
				: parseFloat(shipmentTypes.posti.club).toFixed(2);
			templateData.reservation.shipmentFee = {
				posti: parseFloat(shipmentTypes.posti.club).toFixed(2),
				kotiintoimitus: parseFloat(shipmentTypes.kotiintoimitus.club).toFixed(
					2
				),
				special: parseFloat(shipmentTypes.special.club).toFixed(2),
			};

			if (hasCustomShipmentTypes) {
				let cheapestDeliveryFee = false;
				for (const shipment of customShipmentTypes) {
					templateData.reservation.shipmentFee[shipment.id] = parseFloat(
						shipment.club
					).toFixed(2);
					if (!cheapestDeliveryFee || shipment.club < cheapestDeliveryFee) {
						cheapestDeliveryFee = shipment.club;
					}
				}
				if (cheapestDeliveryFee) {
					templateData.reservation.deliveryFee = cheapestDeliveryFee;
				}
			}

			// Check for free delivery
			if (templateData.reservation && templateData.reservation.items) {
				// Use store price for free delivery calculation instead of online price
				const storePrice = templateData.reservation.storePrice || templateData.reservation.items[0].price;
				if (
					parseFloat(storePrice) >= 50
					&& userInfo.level
					&& userInfo.level === 'gold'
					&& !hasCustomShipmentTypes
				) {
					if (!templateData.reservation.specialDelivery) {
						templateData.reservation.deliveryFee = '0.00';
					}
					templateData.reservation.shipmentFee.posti = parseFloat(0).toFixed(2);
				}
			}
		} else {
			templateData.reservation.deliveryFee = templateData.reservation
				.specialDelivery
				? parseFloat(shipmentTypes.special.default).toFixed(2)
				: parseFloat(shipmentTypes.posti.default).toFixed(2);
			templateData.reservation.shipmentFee = {
				posti: parseFloat(shipmentTypes.posti.default).toFixed(2),
				kotiintoimitus: parseFloat(
					shipmentTypes.kotiintoimitus.default
				).toFixed(2),
				special: parseFloat(shipmentTypes.special.default).toFixed(2),
			};

			if (hasCustomShipmentTypes) {
				let cheapestDeliveryFee = false;

				for (const shipment of customShipmentTypes) {
					templateData.reservation.shipmentFee[shipment.id] = parseFloat(
						shipment.default
					).toFixed(2);
					if (!cheapestDeliveryFee || shipment.default < cheapestDeliveryFee) {
						cheapestDeliveryFee = shipment.default;
					}
				}
				if (cheapestDeliveryFee) {
					templateData.reservation.deliveryFee = cheapestDeliveryFee;
				}
			}
		}
	}

	/**
	 * renderData
	 */
	function renderData() {
		filterStoresbyCity();
		orderStoresByLocation();

		if (!templateData.geoLocation.enabled) {
			templateData.stores.sort(function (a, b) {
				return b.balanceData.balance - a.balanceData.balance;
			});
		}

		// Sort prioritized store to the top if 'store' URL parameter is present
		const urlParams = new URLSearchParams(window.location.search);
		const prioritizedStoreParam = urlParams.get('store');

		if (prioritizedStoreParam) {
			const paramTokens = prioritizedStoreParam.toLowerCase().split(/[\s-]+/).filter((t) => t);

			templateData.stores.sort(function (a, b) {
				function checkMatch(store) {
					const name = (store.storeData.name || '').toLowerCase();
					const city = (store.storeData.city || '').toLowerCase();
					const searchStr = name + ' ' + city;
					return paramTokens.every((token) => searchStr.includes(token));
				}

				const aMatch = checkMatch(a);
				const bMatch = checkMatch(b);

				if (aMatch && !bMatch) {
					return -1;
				}
				if (!aMatch && bMatch) {
					return 1;
				}
				return 0;
			});
		}

		deliveryFee();

		// Sync product question values from the product page before rendering
		updateProductQuestions();

		$('#click-and-collect-content').html(
			Mustache.render(template, templateData)
		);

		const inlineTemplateData = $.extend({}, templateData);
		inlineTemplateData.stores = templateData.stores.slice(0, 3);

		if (templateData.disableCc) {
			$('.store-availability').empty();
		} else {
			$('.store-availability').html(
				Mustache.render(productPageTemplate, inlineTemplateData)
			);
		}
		const $reservationForm = $('.click-and-collect-reservation-form');
		if ($reservationForm.length) {
			inputFilteringEvents($reservationForm);
		}

		// Render product questions (e.g., skier height/weight) into the reservation form
		// This is a fallback if the Mustache template doesn't include the product questions section
		renderProductQuestionsInForm();

		// Populate the info preview/detail if AJAX data is already available
		// (renderData re-creates the DOM, so we need to re-inject the content each time)
		const $preview = $('.cc-product-questions__preview');
		if ($preview.length && templateData.productQuestionsInfoPreview) {
			$preview.html(templateData.productQuestionsInfoPreview);
		}

		$('.prepayment-description').on('click', (e) => {
			e.preventDefault();
			$('#prepayment-description').toggleClass('hidden');
		});

		if (!userInfo) {
			if (hasActiveClickAndCollectSale) {
				$('.cc-info-box.sale-login').removeClass('hidden');
			} else {
				$('.cc-info-box.club-login').removeClass('hidden');
			}
		} else {
			$('.show-for-online-payment').removeClass('hidden');
		}

		$('.cc-info-box.plussa-campaign-info').toggleClass('hidden', true);
		$('.cc-info-box.sale-login').toggleClass('hidden', true);
		$('.cc-info-box.brand-sale-info').toggleClass('hidden', true);
		$('.cc-info-box.from-normal-price-sale-info').toggleClass('hidden', true);
		infoTextAccordion();
	}

	/**
	 * storeScrollPosition
	 *
	 * @param {jQuery} $el
	 * @param {Number} [pos]
	 */
	function storeScrollPosition($el, pos = $el.scrollTop()) {
		$el.data('scrollPosition', pos);
	}

	/**
	 * restoreScrollPosition
	 *
	 * @param {jQuery} $el
	 */
	function restoreScrollPosition($el) {
		$el.scrollTop($el.data('scrollPosition'));

		$el.data('scrollPosition', 0);
	}

	/**
	 * Fetch new token for the form and auto submit it
	 *
	 * @param {jQuery} $form
	 */
	function updateFormToken($form) {
		const $fields = $('input[name$="token"]').val('');

		return getToken().then(function (response) {
			$fields.val(response);
			$('input[name="stage_token"]').val(response);
			if ($form) {
				$form.trigger('submit');
			}
		});
	}

	/**
	 * getTimestamp
	 *
	 * @return {Number}
	 */
	function getTimestamp() {
		return Math.floor(Date.now() / 1000);
	}

	/**
	 * calculateDistance
	 *
	 * @param {Number} lat1
	 * @param {Number} lon1
	 * @param {Number} lat2
	 * @param {Number} lon2
	 *
	 * @return {Number}
	 */
	function calculateDistance(lat1, lon1, lat2, lon2) {
		const toRad = (val) => {
			return (val * Math.PI) / 180;
		};
		const R = 6371; // km
		const dLat = toRad(lat2 - lat1);
		const dLon = toRad(lon2 - lon1);

		lat1 = toRad(lat1);
		lat2 = toRad(lat2);

		const a =
			Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		const d = R * c; //calculate distance between lat/lon
		return d;
	}

	/**
	 * getProductQuestions
	 * Extracts product questions (e.g., skier height/weight) from the product page
	 *
	 * @return {Array} Array of question objects with label, value, unit, type, and input attributes
	 */
	function getProductQuestions() {
		const questions = [];
		const $productQuestions = $('.product-questions');

		if ($productQuestions.length) {
			$productQuestions.find('.product-question input').each(function (index) {
				const $input = $(this);
				const label = $input.data('label') || $input.closest('.product-question').find('label').text().trim();
				const unit = $input.data('unit') || '';
				const type = $input.data('type') || $input.attr('type') || 'text';
				const min = $input.attr('min') || '';
				const max = $input.attr('max') || '';
				const step = $input.attr('step') || '';
				const required = $input.prop('required');
				const value = $input.val() || '';
				const id = $input.attr('id') || '';

				questions.push({
					id,
					index,
					label,
					unit,
					type,
					min,
					max,
					step,
					required,
					requiredAttr: required ? 'required' : '',
					requiredMark: required ? '*' : '',
					minAttr: min ? `min="${min}"` : '',
					maxAttr: max ? `max="${max}"` : '',
					stepAttr: step ? `step="${step}"` : '',
					hasUnit: !!unit,
					value,
				});
			});
		}

		return questions;
	}

	/**
	 * updateProductQuestions
	 * Syncs the current values from the product page question inputs to templateData
	 * Should be called before rendering the form to ensure latest values are used
	 */
	function updateProductQuestions() {
		const $productQuestions = $('.product-questions');

		if ($productQuestions.length && templateData.productQuestions.length > 0) {
			$productQuestions.find('.product-question input').each(function (index) {
				if (templateData.productQuestions[index]) {
					templateData.productQuestions[index].value = $(this).val() || '';
				}
			});
		}

		// Also update hasProductQuestions flag
		templateData.hasProductQuestions = templateData.productQuestions.length > 0;
	}

	/**
	 * renderProductQuestionsInForm
	 * Injects product questions HTML into the click-and-collect reservation form
	 * This is a fallback for when the Mustache template doesn't include the product questions section
	 */
	function renderProductQuestionsInForm() {
		const $form = $clickAndCollect.find('.click-and-collect-reservation-form');
		if (!$form.length || templateData.productQuestions.length === 0) {
			return;
		}

		// Check if questions are already rendered (either by Mustache template or previous JS injection)
		if ($form.find('.cc-product-questions').length) {
			// If rendered by Mustache, the values may need to be synced from the product page
			// The Mustache template uses {{value}} which gets the synced value from updateProductQuestions()
			return;
		}

		// Build questions HTML (fallback injection if Mustache template doesn't render questions)
		let questionsHtml = `
			<div class="cc-product-questions">
				<div class="cc-product-questions__title">Käyttäjätiedot</div>
				<div class="cc-product-questions__fields">
		`;

		templateData.productQuestions.forEach((question, index) => {
			const requiredAttr = question.required ? 'required' : '';
			const requiredMark = question.required ? '*' : '';
			const minAttr = question.min ? `min="${question.min}"` : '';
			const maxAttr = question.max ? `max="${question.max}"` : '';
			const stepAttr = question.step ? `step="${question.step}"` : '';

			questionsHtml += `
				<div class="cc-product-questions__field">
					<label for="cc-question-${index}" class="cc-product-questions__label">${question.label}${requiredMark}</label>
					<div class="cc-product-questions__input-wrapper">
						<input
							type="${question.type}"
							id="cc-question-${index}"
							name="product_questions[${index}][value]"
							data-label="${question.label}"
							data-unit="${question.unit}"
							class="input form-control cc-product-questions__input"
							value="${question.value}"
							${minAttr}
							${maxAttr}
							${stepAttr}
							${requiredAttr}
						>
						<input type="hidden" name="product_questions[${index}][label]" value="${question.label}">
						<input type="hidden" name="product_questions[${index}][unit]" value="${question.unit}">
						${question.unit ? `<span class="cc-product-questions__unit">${question.unit}</span>` : ''}
					</div>
				</div>
			`;
		});

		questionsHtml += `
				</div>
				<p class="cc-product-questions__info">Tarvitsemme pituus- ja painotietoa oikean jäykkyyksisen suksen valintaan.</p>
				${templateData.hasProductQuestionsInfoLink ? `<div class="cc-product-questions__preview">${templateData.productQuestionsInfoPreview || ''}</div><div class="cc-product-questions__detail hidden"></div><p class="cc-product-questions__read-more"><a href="#" class="cc-product-questions__toggle">Lue lisää</a></p>` : ''}
			</div>
		`;

		// Insert after the phone/email fields (before address fields or shipment type)
		const $addressField = $form.find('input[name="address"]').closest('.field');
		const $shipmentType = $form.find('.click-and-collect-shipment-type');

		if ($addressField.length) {
			$addressField.before(questionsHtml);
		} else if ($shipmentType.length) {
			$shipmentType.before(questionsHtml);
		} else {
			// Fallback: insert before the consent checkboxes
			$form.find('.consent-checkboxes').closest('.form-input').before(questionsHtml);
		}
	}

	/**
	 * formatPrice
	 *
	 * @param {Number|String}  price
	 * @param {Boolean} [appendEuro]
	 *
	 * @return {String}
	 */
	function formatPrice(price, appendEuro = true) {
		let formattedPrice = '';

		try {
			formattedPrice =
				parseFloat(price)
					.toFixed(2)
					.replace('.', ',')
					.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + (appendEuro ? ' €' : '');
		} catch (e) {
			formattedPrice = price;
		}

		return formattedPrice;
	}
}
